import React from "react";
import { ensure, GridColumn, GridRow, LabeledText, Stack } from "sprint-common-web";

import { ensureAncillaryContentSubtype } from "../../../../../common/types/AncillaryContentType";
import { ContentSubtype } from "../../../../../common/types/ContentSubtype";
import { FileRecordDetails } from "../../FileRecordDetails";
import { FileRecordAncillaryVersionInfo } from "./FileRecordAncillaryVersionInfo";

interface FileRecordAncillaryContentViewProps {
    fileRecordDetails: FileRecordDetails;
}

export const FileRecordAncillaryContentView = ({
    fileRecordDetails
}: FileRecordAncillaryContentViewProps): JSX.Element => {
    ensure(fileRecordDetails.content);
    ensureAncillaryContentSubtype(fileRecordDetails.content.contentSubtype);

    return (
        <Stack>
            <GridRow>
                <GridColumn sm={6}>
                    <LabeledText
                        label="Title"
                        value={fileRecordDetails.content.ancillary.name}
                        maxLength={40}
                        testId="ancillary-name-field"
                        textTooltip
                    />
                    <LabeledText
                        label="Content type"
                        value={ContentSubtype[fileRecordDetails.content.contentSubtype]}
                        testId="ancillary-content-type-field"
                    />
                    <LabeledText
                        label="Airline"
                        value={fileRecordDetails.content.airline.name}
                        testId="ancillary-airline-field"
                        textTooltip
                    />
                </GridColumn>
                <GridColumn sm={6}>
                    <FileRecordAncillaryVersionInfo ancillaryId={fileRecordDetails.content.ancillary.id} />
                </GridColumn>
            </GridRow>
        </Stack>
    );
};
